module.exports = __webpack_public_path__ + "static/media/ASxpert-logo.83ab2c4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/ASxpert-logo.png
// module id = 322
// module chunks = 0